import { useSelector } from 'react-redux';

export const useSelectProducts = () => useSelector(({ cart }) => cart?.products ?? []);